import React from 'react';
import { InventoryEntities } from 'client/data/models/inventory';
import { WarrantyShortDescriptionLine } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-short-description-line/warranty-short-description-line';
import { WarrantyConditions } from 'site-modules/shared/components/inventory/warranty-module/warranty-item/warranty-conditions/warranty-conditions';

export function WarrantyShortOriginalDescriptionLine(props) {
  const { warrantyItem } = props;

  return (
    <WarrantyShortDescriptionLine
      label="Original"
      value={<WarrantyConditions warrantyItem={warrantyItem} delimiter="or" weight="normal" />}
    />
  );
}

WarrantyShortOriginalDescriptionLine.propTypes = {
  warrantyItem: InventoryEntities.WarrantyItem.isRequired,
};
